import { useCallback, useEffect, useState } from 'react'

export function useMaxWidth() {
  const [width, setWidth] = useState(window.screenDetectResult.maxWidth)
  const [safeAreaTop, setSafeAreaTop] = useState(
    window.screenDetectResult.safeAreaTop
  )

  const updateWidth = useCallback(() => {
    setWidth(window.screenDetectResult.maxWidth)
    setSafeAreaTop(window.screenDetectResult.safeAreaTop)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateWidth)

    return () => {
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  return {
    width,
    safeAreaTop,
  }
}
